import { ClassroomDetails } from "@/stores/classroomStore_I";
import * as api from "@/js/api/classApi";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

const keyPrefix = "classroomDetails";

export function useClassroomDetailsQuery(
	classroomId: string,
	includeStudents: boolean,
	includeTeachers: boolean,
	includeRules: boolean,
	type: "CLASSROOM" | "GROUP",
	sourceId: string,
	teacherId: string,
	queryOptions = {}
): UseQueryResult<{ classroom: ClassroomDetails }> {
	const key = [keyPrefix, classroomId, includeStudents, includeTeachers, includeRules, type, sourceId, teacherId];
	const query = useQuery(
		key,
		() => api.getClassroomDetails(classroomId, includeStudents, includeTeachers, includeRules, type, sourceId, teacherId),
		queryOptions
	);
	return query;
}

export function makeClassroomDetailsInvalidationKey(classroomId: string): string[] {
	return [keyPrefix, classroomId];
}
